export default "__VITE_ASSET__540f994b__"